import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import { NotationSearchByTextModuleFactory } from '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { getAssetClassId, getLanguage, getEndpointOptions } from '../../helpers/common.js';

var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
class SearchSuggesterStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultNameType = "name";
    this.defaultLanguage = "en";
    this.defaultFallbackForNameType = true;
    this.defaultSearchAttributes = ["isin", "symbol", "longName", "shortName"];
    this.defaultSorting = ["instrument.name.default.long"];
    this.termMinimumCharactersRequired = 2;
    this.validationPattern = /^[ -&(-+-/0-:=?@A-~a-~À-ÿ"'.&]{2,50}$/;
    this.genericAttributes = (_d = (_c = (_b = (_a = this.options) == null ? void 0 : _a.assetClass) == null ? void 0 : _b.generic) == null ? void 0 : _c.attributes) != null ? _d : this.defaultSearchAttributes;
    this.genericSort = (_h = (_g = (_f = (_e = this.options) == null ? void 0 : _e.assetClass) == null ? void 0 : _f.generic) == null ? void 0 : _g.sort) != null ? _h : this.defaultSorting;
    this.searchTermValidationPattern = (_l = (_k = (_j = (_i = this.options) == null ? void 0 : _i.searchTerm) == null ? void 0 : _j.validationRules) == null ? void 0 : _k.pattern) != null ? _l : this.validationPattern;
  }
  getNameType(assetClass) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
    return (_l2 = (_k2 = (_e2 = (_d2 = (_c2 = (_b2 = (_a2 = this.options) == null ? void 0 : _a2.assetClass) == null ? void 0 : _b2[assetClass]) == null ? void 0 : _c2.instrument) == null ? void 0 : _d2.name) == null ? void 0 : _e2.type) != null ? _k2 : (_j2 = (_i2 = (_h2 = (_g2 = (_f2 = this.options) == null ? void 0 : _f2.assetClass) == null ? void 0 : _g2.generic) == null ? void 0 : _h2.instrument) == null ? void 0 : _i2.name) == null ? void 0 : _j2.type) != null ? _l2 : this.defaultNameType;
  }
  getNonGenericAssetClasses(payload) {
    return payload.assetClasses.filter((assetClass) => assetClass !== "generic");
  }
  getNotationSearchByTextData(payload, assetClass) {
    var _a2;
    const request = assetClass ? this.getNotationSearchByTextRequest(payload, assetClass) : this.getGenericNotationSearchByTextRequest(payload);
    const response = this.getEndpoints().notationSearchByText.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getInstrumentAssetClass(searchResult) {
    var _a2, _b2;
    return (_b2 = (_a2 = searchResult.instrument.assetClass.name) == null ? void 0 : _a2.replace("debt", "bond")) != null ? _b2 : "generic";
  }
  isNameTypeFallbackEnabled(assetClass) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
    return (_l2 = (_k2 = (_e2 = (_d2 = (_c2 = (_b2 = (_a2 = this.options) == null ? void 0 : _a2.assetClass) == null ? void 0 : _b2[assetClass]) == null ? void 0 : _c2.instrument) == null ? void 0 : _d2.name) == null ? void 0 : _e2.fallback) != null ? _k2 : (_j2 = (_i2 = (_h2 = (_g2 = (_f2 = this.options) == null ? void 0 : _f2.assetClass) == null ? void 0 : _g2.generic) == null ? void 0 : _h2.instrument) == null ? void 0 : _i2.name) == null ? void 0 : _j2.fallback) != null ? _l2 : this.defaultFallbackForNameType;
  }
  getNotationId(searchResult) {
    if (!searchResult.id) {
      throw new Error("Could not get notation id");
    }
    return searchResult.id;
  }
  getEmptyResponseItem(payload, searchResult) {
    return {
      id: null,
      name: null,
      isin: null,
      assetClass: null
    };
  }
  getResponseItem(payload, searchResult) {
    var _a2, _b2, _c2;
    try {
      const instrumentAssetClass = this.getInstrumentAssetClass(searchResult);
      const nameType = this.getNameType(instrumentAssetClass);
      const isNameTypeFallbackEnabled = this.isNameTypeFallbackEnabled(instrumentAssetClass);
      const nameAttribute = nameType === "name" ? "long" : "short";
      const nameFallback = isNameTypeFallbackEnabled ? (_a2 = searchResult.instrument.name.default.long) != null ? _a2 : null : null;
      return {
        id: this.getNotationId(searchResult),
        name: (_b2 = searchResult.instrument.name.default[nameAttribute]) != null ? _b2 : nameFallback,
        isin: (_c2 = searchResult.instrument.isin) != null ? _c2 : null,
        assetClass: instrumentAssetClass
      };
    } catch (error) {
      return this.getEmptyResponseItem(payload, searchResult);
    }
  }
  getNonGenericAssetClassData(payload) {
    const nonGenericAssetClasses = this.getNonGenericAssetClasses(payload);
    const resultsPerNonGenericAssetClass = nonGenericAssetClasses.map((assetClass) => this.getNotationSearchByTextData(payload, assetClass)).filter((result) => result !== null);
    if (resultsPerNonGenericAssetClass.length === 0) {
      return null;
    }
    return resultsPerNonGenericAssetClass.flat().map((result) => this.getResponseItem(payload, result));
  }
  getGenericAssetClassData(payload) {
    var _a2;
    const notationSearchByTextData = this.getNotationSearchByTextData(payload);
    return (_a2 = notationSearchByTextData == null ? void 0 : notationSearchByTextData.map((searchResult) => this.getResponseItem(payload, searchResult))) != null ? _a2 : null;
  }
  getResponseData(payload) {
    return payload.assetClasses.length > 0 ? this.getNonGenericAssetClassData(payload) : this.getGenericAssetClassData(payload);
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  getResponseMeta(payload) {
    return {
      validationRules: {
        searchTerm: {
          pattern: this.searchTermValidationPattern
        }
      }
    };
  }
  async updateNotationSearchByText(payload, assetClass) {
    const request = assetClass ? this.getNotationSearchByTextRequest(payload, assetClass) : this.getGenericNotationSearchByTextRequest(payload);
    return this.getEndpoints().notationSearchByText.updateState(request);
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    if (!payload.searchTerm || payload.searchTerm.length < this.termMinimumCharactersRequired) {
      return Promise.resolve(true);
    }
    try {
      if (payload.assetClasses.length > 0) {
        const nonGenericAssetClasses = this.getNonGenericAssetClasses(payload);
        await Promise.all(nonGenericAssetClasses.map(async (assetClass) => this.updateNotationSearchByText(payload, assetClass)));
      } else {
        await this.updateNotationSearchByText(payload);
      }
    } catch (e) {
      this.logger.error(e);
      isResponseSuccessful = false;
    }
    return isResponseSuccessful;
  }
  getAttributes(assetClass) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    return (_h2 = (_g2 = (_c2 = (_b2 = (_a2 = this.options) == null ? void 0 : _a2.assetClass) == null ? void 0 : _b2[assetClass]) == null ? void 0 : _c2.attributes) != null ? _g2 : (_f2 = (_e2 = (_d2 = this.options) == null ? void 0 : _d2.assetClass) == null ? void 0 : _e2.generic) == null ? void 0 : _f2.attributes) != null ? _h2 : this.defaultSearchAttributes;
  }
  getSort(assetClass) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    return (_h2 = (_g2 = (_c2 = (_b2 = (_a2 = this.options) == null ? void 0 : _a2.assetClass) == null ? void 0 : _b2[assetClass]) == null ? void 0 : _c2.sort) != null ? _g2 : (_f2 = (_e2 = (_d2 = this.options) == null ? void 0 : _d2.assetClass) == null ? void 0 : _e2.generic) == null ? void 0 : _f2.sort) != null ? _h2 : this.defaultSorting;
  }
  getNotationSearchByTextRequest(payload, assetClass) {
    var _a2, _b2, _c2, _d2;
    const criteria = (_c2 = (_a2 = payload.criteria) == null ? void 0 : _a2[assetClass]) != null ? _c2 : (_b2 = payload.criteria) == null ? void 0 : _b2.generic;
    return {
      data: {
        text: {
          attributes: this.getAttributes(assetClass),
          value: payload.searchTerm
        },
        ...criteria,
        assetClasses: {
          ids: [(_d2 = getAssetClassId(assetClass)) != null ? _d2 : NaN]
        }
      },
      meta: {
        language: getLanguage(payload.language, this.defaultLanguage, this.options),
        sort: this.getSort(assetClass),
        pagination: {
          limit: payload.numberOfItemsPerAssetClass
        }
      }
    };
  }
  getGenericNotationSearchByTextRequest(payload) {
    var _a2;
    return {
      data: {
        text: {
          attributes: this.genericAttributes,
          value: payload.searchTerm
        },
        ...(_a2 = payload.criteria) == null ? void 0 : _a2.generic
      },
      meta: {
        language: getLanguage(payload.language, this.defaultLanguage, this.options),
        sort: this.genericSort,
        pagination: {
          limit: payload.numberOfItemsPerAssetClass
        }
      }
    };
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.endpoints = {
        notationSearchByText: this.getModuleEntity(NotationSearchByTextModuleFactory, getEndpointOptions(endpointConfiguration, "notationSearchByText"))
      };
    }
    return this.endpoints;
  }
}

export { SearchSuggesterStoreModuleFactory };
